import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { userDetailsSelector } from 'auth/selectors'

/**
 *
 * @param {callback} handleChange - called with argument. If `true` new user is logged in, if `false` user is logged out
 */
export const useOnUserChange = handleChange => {
    const userDetails = useSelector(userDetailsSelector)

    useEffect(() => {
        if (Object.keys(userDetails).length > 0) {
            handleChange(true) // login
        } else {
            handleChange(false) // logout
        }
    }, [userDetails])
}
